import { VscInfo } from "react-icons/vsc";
import { CollapsibleButtonContainer } from "./collapsible-button.style";
import { ICollapsibleButtonProps } from "./types";

export const CollapsibleButton = ({ onClick }: ICollapsibleButtonProps) => {
  return (
    <CollapsibleButtonContainer onClick={onClick} role="button">
      <VscInfo size={22} />
      <span className="info_text">راهنما</span>
    </CollapsibleButtonContainer>
  );
};
